import React, { useEffect, useRef } from 'react';
import './TestWidget.css';

interface TestWidgetProps {
  isVisible: boolean;
  onClose: () => void;
  onTestComplete?: () => void;
}

const TestWidget: React.FC<TestWidgetProps> = ({ isVisible, onClose, onTestComplete }) => {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible && widgetRef.current) {
      // Очищаем предыдущий виджет если есть
      widgetRef.current.innerHTML = '';
      
      // Создаем новый div для виджета
      const widgetDiv = document.createElement('div');
      widgetDiv.id = 'otp_wgt_cd4it3annc53k';
      widgetRef.current.appendChild(widgetDiv);

      // Добавляем обработчик сообщений от виджета
      const handleMessage = (event: MessageEvent) => {
        if (event.data && event.data.type === 'onlinetestpad_test_complete') {
          if (onTestComplete) {
            onTestComplete();
          }
          onClose();
        }
      };

      window.addEventListener('message', handleMessage);

      // Добавляем скрипт виджета
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        var otp_wjs_dt = (new Date).getTime();
        (function (w, d, n, s, rp) {
            w[n] = w[n] || [];
            rp = {};
            w[n].push(function () {
                otp_render_widget(d.getElementById("otp_wgt_cd4it3annc53k"), 'onlinetestpad.com', 'cd4it3annc53k', rp);
            }); 
            s = d.createElement("script");
            s.type = "text/javascript";
            s.src = "//onlinetestpad.com/js/widget.js?" + otp_wjs_dt;
            s.async = true;
            d.getElementsByTagName("head")[0].appendChild(s);
        })(window, document, "otp_widget_callbacks");
      `;
      
      document.head.appendChild(script);

      // Очистка при размонтировании
      return () => {
        window.removeEventListener('message', handleMessage);
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    }
  }, [isVisible, onClose, onTestComplete]);

  const handleSubmit = async () => {
    try {
      // ... existing submit logic ...
      
      // После успешной отправки теста
      if (onTestComplete) {
        onTestComplete();
      }
      
      // ... rest of the code ...
    } catch (error) {
      // ... error handling ...
    }
  };

  if (!isVisible) return null;

  return (
    <div className="test-widget-overlay">
      <div className="test-widget-container">
        <div className="test-widget-header">
          <h3>Теоретический тур - Тестирование</h3>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="test-widget-content" ref={widgetRef}>
          {/* Виджет будет загружен здесь */}
        </div>
      </div>
    </div>
  );
};

export default TestWidget; 